import React, { useContext, useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import EstiloAprendizajeContainer from "./containers/EstiloAprendizaje/EstiloAprendizajeContainer";
import axios from "./helpers/axios";
import FactorCtContainer from "./containers/FactorCt/FactorCtContainer";
import ReportsContainer from "./containers/Admin/ReportsContainer";
import LoginContainer from "./containers/Login/LoginContainer";
import { AuthContext } from "./context/AuthContextProvider";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/es";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import EstiloNaturalDecisionContainer from "./containers/EstiloNaturalDecision/EstiloNaturalDecisionContainer";

function App() {
  //let affirmationsCopy: Array<Affirmation> = [...affirmations];

  //affirmationsCopy = [
  //    { id: "", order: 1, textEc: "", textOr: "", textCa: "", textEa: "" },

  //];

  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const authContext = useContext(AuthContext);
  const basename = process.env.PUBLIC_URL || "/";

  const setGlobalTitle = (title: string, subtitle: string) => {
    setTitle(title);
    setSubtitle(subtitle);
  };
  const theme = createTheme();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
        {/* {!authContext.isAuthenticated ? (
        <div>Loading...</div>
      ) : ( */}
        <div className="App">
          <Router basename={basename}>
            <Routes>
              <Route
                path="/estilo-aprendizaje"
                element={<EstiloAprendizajeContainer />}
              />
              <Route path="factor-ct" element={<FactorCtContainer />} />
              <Route
                path="estilo-natural-decision"
                element={<EstiloNaturalDecisionContainer />}
              />
              <Route path="/admin/reports" element={<ReportsContainer />} />
              <Route path="login" element={<LoginContainer />} />
            </Routes>
          </Router>
        </div>
        {/* )} */}
      </LocalizationProvider>
    </ThemeProvider>
  );
}

//TODO: Review this information to change the keycloak implementation https://blog.logrocket.com/implement-keycloak-authentication-react/
export default App;
